import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface CreateItemDTO {
  itemId: string;
}

const createItem = async ({
  clientId,
  publicToken,
  isDataReconciliation,
  isAccountVerification,
}: {
  clientId: string | number;
  publicToken: string;
  isDataReconciliation: boolean;
  isAccountVerification: boolean;
}): Promise<CreateItemDTO> =>
  authFetch('/Consumer/PlaidAccountsLinking/CreateItem', {
    method: 'POST',
    ...httpBodyOptions({ clientId, publicToken, isDataReconciliation, isAccountVerification }),
  });

export const usePlaidCreateItemMutation = () => {
  return useMutation(createItem);
};
